import axios from "axios"
import { useEffect,useState } from "react"
import {format,parse} from 'date-fns'
import flecha from '../Img/flecha.png'
import AddProyecto from "./AddProyecto"
import EditProyecto from "./EditProyecto"
import DelProyecto from "./DelProyecto"
export default function Proyectos({usuario}){
    const columnas=["Cliente","Centro","Nombre","Descripción","Inicio","Fin"]
    const [clientes,setClientes]=useState([])
    const [centros,setCentros]=useState([])
    const [proyectos,setProyectos]=useState([])
    const [begin,setBegin]=useState(parse("01/01/2000","dd/MM/yyyy",new Date()))
    const [end,setEnd]=useState(parse(formatString(new Date()),"dd/MM/yyyy",new Date()))
    const [accion,setAccion]=useState("")
    const [i,setI]=useState(-1)
    const [valores,setValores]=useState([])
    const [ids_clientes,setIdsClientes]=useState([])
    const [ids_centros,setIdsCentros]=useState([])
    const ids=[ids_clientes,ids_centros]
    const sets=[setIdsClientes,setIdsCentros]
    const [abiertos,setAbiertos]=useState(true)
    const [cerrados,setCerrados]=useState(true)
    function formatString(date){
        const d = new Date(date)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        return `${dia}/${mes}/${año}`;
    }
    function formatString2(str){
            const d=new Date(str)
            const dia = d.getDate().toString().padStart(2, '0')
            const mes = (d.getMonth() + 1).toString().padStart(2, '0')
            const año = d.getFullYear()
            const hora=d.getHours().toString().padStart(2, '0')
            const min=d.getMinutes().toString().padStart(2, '0')
            const sec=d.getSeconds().toString().padStart(2, '0')
            return `${dia}/${mes}/${año} ${hora}:${min}:${sec}`
    }
    function formatStringReverse(str){
        const d=new Date(str)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        const hora=d.getHours()
        const min=d.getMinutes()
        const sec=d.getSeconds()
        return `${año}/${mes}/${dia} ${hora}:${min}:${sec}`
    }
    const ChangeBegin=(event)=>{
        const valores=event.target.value.split("-")
        if (event.target.value.length==0 || valores[0].length>4){
            setBegin(parse("2000-01-01","yyyy-MM-dd",new Date()))
        }
        else{
            setBegin(parse(event.target.value,"yyyy-MM-dd",new Date()))
            if (parse(event.target.value,"yyyy-MM-dd",new Date())>end){
                setEnd(parse(event.target.value,"yyyy-MM-dd",new Date()))
            }
        }
    }
    const ChangeEnd=(event)=>{
        const valores=event.target.value.split("-")
        if (event.target.value.length==0 || valores[0].length>4){
            setEnd(new Date())
        }
        else{
            setEnd(parse(event.target.value,"yyyy-MM-dd",new Date()))
            if (parse(event.target.value,"yyyy-MM-dd",new Date())<begin){
                setBegin(parse(event.target.value,"yyyy-MM-dd",new Date()))
            }
        }
    }
    useEffect(()=>{
        let clientesOrdenados=[]
        let centrosOrdenados=[]
        axios.get("https://www.asinova.es/webapi/api/Clientes/abierto-cerrado")
            .then(res=>{
                clientesOrdenados=res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre))
                setClientes(clientesOrdenados)
                setIdsClientes(clientesOrdenados.map(x=>x.id))
                valores[0]=clientesOrdenados
                return axios.get("https://www.asinova.es/webapi/api/Centros/abierto-cerrado")})
            .then(res=>{
                centrosOrdenados=res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre)).sort((x, y) => clientesOrdenados.find(cliente=>cliente.id==x.id_cliente).nombre.localeCompare(clientesOrdenados.find(cliente=>cliente.id==y.id_cliente).nombre))
                setCentros(centrosOrdenados)
                setIdsCentros(centrosOrdenados.map(x=>x.id))
                valores[1]=centrosOrdenados
                return axios.get("https://www.asinova.es/webapi/api/Proyectos/abierto-cerrado")})
            .then(res=>{
                setProyectos(res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre)).sort((x,y)=>formatStringReverse(y.inicio).localeCompare(formatStringReverse(x.inicio))))
            })
    },[])
    const CheckboxChange=(index, id, checked)=>{
        const nuevaLista = [...ids[index]]
        nuevaLista[valores[index].findIndex(x => x.id === id)] = checked ? id : ""
        sets[index](nuevaLista)
        if (index==0){
            const nuevaListaCentros=[...ids[1]]
            for (var j=0; j<centros.length; j++){
                if (centros[j].id_cliente==id)
                nuevaListaCentros[j]=checked ? centros[j].id : "no"
            }
            sets[1](nuevaListaCentros)
        }
    }
    const invertir=(index)=>{
        const nuevaLista = [...ids[index]]
        for (var j=0; j<nuevaLista.length; j++){
            if (nuevaLista[j]!="no"){
                nuevaLista[j]=nuevaLista[j]==""?valores[index][j].id:""
            }
        }
        if (index==0){
            const nuevaListaCentros=[...ids[1]]
            for (var j=0; j<centros.length; j++){
                nuevaListaCentros[j]=nuevaLista.includes(centros[j].id_cliente) ? centros[j].id : "no"
            }
            sets[1](nuevaListaCentros)
        }
        sets[index](nuevaLista)
    }
    const todos=(index)=>{
        const nuevaLista = [...ids[index]]
        for (var j=0; j<nuevaLista.length; j++){
            if (nuevaLista[j]!="no"){
                nuevaLista[j]=valores[index][j].id
            }
        }
        if (index==0){
            const nuevaListaCentros=[...ids[1]]
            for (var j=0; j<centros.length; j++){
                nuevaListaCentros[j]=nuevaLista.includes(centros[j].id_cliente) ? centros[j].id : "no"
            }
            sets[1](nuevaListaCentros)
        }
        sets[index](nuevaLista)
    }
    const Limpiar=()=>{
        for (var j=0; j<sets.length; j++){
            sets[j](valores[j].map(x=>x.id))
        }
        parse("01/01/2000","dd/MM/yyyy",new Date())
        parse(formatString(new Date()),"dd/MM/yyyy",new Date())
    }
    return(
        <>
            <h1 style={{textAlign:'center',margin:'1rem'}}>PROYECTOS</h1>
            {usuario.administrador?
            <div className="div-opciones">
                <a className="btn-form" onClick={()=>setAccion(accion=="post"?"":"post")}>Añadir</a>
                <a className="btn-form" onClick={()=>setAccion(accion=="put"?"":"put")}>Editar</a>
                <a className="btn-form" onClick={()=>setAccion(accion=="delete"?"":"delete")}>Eliminar</a>
            </div>
            :null}
            <div className="flex mid" style={{margin:'0 auto'}}>
                <p>Inicio</p>
                <input type="date" name='inicio' value={format(begin,"yyyy-MM-dd")} style={{marginTop:0}} onChange={ChangeBegin}/>
                <div className="flex column" style={{marginBottom:'1rem'}}>
                    <img src={flecha} style={{width:'30px',marginBottom:'1rem'}} className='pointer' onClick={()=>setEnd(begin)}/>
                    <img src={flecha} style={{width:'30px',transform:'rotate(180deg)'}} className='pointer' onClick={()=>setBegin(end)}/>
                </div>
                <input type="date" name="fin" value={format(end,"yyyy-MM-dd")} style={{marginTop:0}} onChange={ChangeEnd}/>
                <p>Fin</p>
            </div>
            <div className='flex' style={{justifyContent:'center',width:'fit-content',margin:'0 auto'}}>
                <div style={{margin:'0.5rem 1rem',width:'fit-content',marginTop:'0'}}>
                    <input type="checkbox" id={"abiertos"} name={"abiertos"} style={{margin:'0'}} checked={abiertos} onChange={()=>{setAbiertos(!abiertos)}}/>
                    <label for={"abiertos"} style={{margin:'0 0.5rem'}}>Abiertos</label>
                </div>
                <div style={{margin:'0.5rem 1rem',width:'fit-content',marginTop:'0'}}>
                    <input type="checkbox" id={"cerrados"} name={"cerrados"} style={{margin:'0'}} checked={cerrados} onChange={()=>{setCerrados(!cerrados)}}/>
                    <label for={"cerrados"} style={{margin:'0 0.5rem'}}>Cerrados</label>
                </div>
            </div>
            <table style={{margin:'0rem auto 1rem auto',borderRadius:'5px'}}>
                <tr>
                    {columnas.map((col,index)=>(
                        <th key={index} style={{padding:0,position:'relative',overflow:'visible'}}><p style={{margin:0,padding:'0.5rem 1.5rem',backgroundColor:index<2 && ids[index].find(x=>x=="")!=null?'aqua':''}} onClick={()=>{
                            if (index<2){
                                setI(i==index?-1:index);
                            }
                            else{
                                setI(-1)
                            }
                        }}>{col}</p>
                        {index==i && i<2?
                            <div className="filtro">
                                {valores[index].filter(x=>ids[index][valores[index].indexOf(x)]!="no").map((x,n)=>(
                                    <div>
                                        <input type="checkbox" id={x.id} name={x.id} value={x.id} checked={ids[index].includes(x.id)} onChange={(e)=>CheckboxChange(index,x.id,e.target.checked)}/>
                                        <label for={x.id} style={{margin:'0 0.5rem'}}>{x.nombre}</label>
                                    </div>
                                ))}
                                <div style={{padding:'0.5rem 0.5rem',border:'1px solid white',backgroundColor:'#101218',color:'white',justifyContent:'space-between'}} className='flex'>
                                    <a onClick={()=>invertir(index)} className='btn-form' style={{fontSize:'0.8rem',padding:'0 0.5rem',marginRight:'1rem'}}>Invertir</a>
                                    <a onClick={()=>todos(index)} className='btn-form' style={{fontSize:'0.8rem',padding:'0 0.5rem',margin:0}}>Todos</a>
                                </div>
                            </div>
                        :null}</th>))}
                </tr>
                {proyectos.filter(x=>ids_clientes.includes(centros.find(c=>c.id==x.id_centro).id_cliente) && ids_centros.includes(x.id_centro) && new Date(x.inicio)>=begin && parse(formatString(new Date(x.inicio)),"dd/MM/yyyy",new Date())<=end && (parse(formatString(new Date(x.fin)),"dd/MM/yyyy",new Date())<=end || x.fin==null) && ((x.abierto && abiertos) || (!x.abierto && cerrados))).map(x=>(
                    <tr><td>{clientes.find(y=>y.id==centros.find(z=>z.id==x.id_centro).id_cliente).nombre}</td><td>{centros.find(y=>x.id_centro==y.id).nombre}</td><td>{x.nombre}</td><td style={{maxWidth:'250px'}}>{x.descripcion}</td><td>{formatString2(x.inicio)}</td><td>{x.fin==null?"No terminado":formatString2(x.fin)}</td></tr>
                ))}
            </table>
            {accion!=""?
                <div className="ventana-emergente">
                    <a className="btn-form" onClick={()=>setAccion("")} style={{padding:'0.1rem 0.45rem',marginTop:'1rem',float:'right'}}>X</a>
                    {accion=="post"?
                    <AddProyecto clientes={clientes} centros={centros.filter(x=>x.abierto)} setProyectos={setProyectos}/>:
                    accion=="put"?
                    <EditProyecto clientes={clientes} centros={centros.filter(x=>x.abierto)} proyectos={proyectos.filter(x=>centros.find(y=>y.id==x.id_centro && y.abierto)!=null)} setProyectos={setProyectos}/>:
                    <DelProyecto clientes={clientes} centros={centros} proyectos={proyectos} setProyectos={setProyectos}/>
                    }
                </div>
                :null}
        </>
    )
}